<template>
	<div class="page">
		<div class="topView">
			<div class="topViewL" v-if="detailData != null">
				<div></div>
				<div v-if="detailData.order_type_id == 3">处方订单详情</div>
			</div>
			<div class="topViewR" v-if="detailData != null">
				<el-button type="primary" v-if="detailData.state == 5 || detailData.state == 8"
					@click="drawerWuliuxinxi_state = true">物流信息
				</el-button>
				<el-button type="primary" v-if="detailData.state == 5" plain @click="handelReceivingClick">确认收货</el-button>
				<el-button type="primary" v-if="detailData.state == 3" plain @click="handelConfirmClick">确认发货</el-button>
				<el-button type="primary" plain @click="handleBackClick">返回</el-button>
			</div>
		</div>
		<div class="detailView" v-if="detailData != null">
			<div class="detailViewName">订单信息</div>
			<div class="detailRow">
				<div class="detailCol">
					<div>订单编号：</div>
					<div>{{ detailData.no }}</div>
				</div>
				<div class="detailCol">
					<div>订单类型：</div>
					<div>商品</div>
				</div>
				<div class="detailCol">
					<div>订单状态：</div>
					<div v-if="detailData.state == 1">已创建</div>
					<div v-if="detailData.state == 2">支付中</div>
					<div v-if="detailData.state == 3">支付成功</div>
					<div v-if="detailData.state == 5">已发货</div>
					<div v-if="detailData.state == 8">已完成</div>
					<div v-if="detailData.state == -2">已取消</div>
					<div v-if="detailData.state == -3">退款中</div>
					<div v-if="detailData.state == -4">退款成功</div>
				</div>
				<div class="detailCol">
					<div>下单时间：</div>
					<div>{{ $public.FTime(detailData.create_time, "YYYY-MM-DD HH:mm:ss") }}</div>
				</div>
			</div>
			<div class="detailRow">
				<div class="detailCol">
					<div>用户名：</div>
					<div>{{user_info.nick_name}}</div>
				</div>
				<div class="detailCol">
					<div>注册电话：</div>
					<div>{{user_info.user_mobile}}</div>
				</div>
				<div class="detailCol">
					<div>收货人：</div>
					<div>{{ online_order_data.ship_adddress==null? '--' : online_order_data.ship_adddress.user_name }}</div>
				</div>
				<div class="detailCol">
					<div>收货电话：</div>
					<div>{{ online_order_data.ship_adddress== null ? '--' :online_order_data.ship_adddress.phone }}</div>
				</div>
			</div>
			<div class="detailRow">
				<div class="detailCol">
                    <div>配送方式：</div>
                    <div v-if="online_order_data&&online_order_data.distribution_type == 1">邮递配送</div>
                    <div v-if="online_order_data&&online_order_data.distribution_type == 2">门店自提</div>
                </div>
				<div class="detailCol" v-if="online_order_data&&online_order_data.distribution_type == 1">
					<div>快递单号：</div>
					<div>{{ online_order_data ==null ? '--': online_order_data.ship_name + online_order_data.ship_no  }}</div>
				</div>
				<div class="detailCol" v-if="online_order_data&&online_order_data.distribution_type == 1">
					<div>运费：</div>
					<div>{{ detailData.postage }}</div>
				</div>
				<div class="detailCol">
					<div>结算方式：</div>
					<template v-if="detailData.pay_info != null">
						<span v-for="(item, index) in detailData.pay_info.pay_list" :key="index">
							<template v-if="item.pay_type == 1">支付宝</template>
							<template v-if="item.pay_type == 2">微信</template>
							<template v-if="item.pay_type == 7">余额</template>
							<template v-if="item.pay_type == 9">积分</template>
							<template v-if="item.pay_type == 17">拉卡拉</template>
						</span>
					</template>
				</div>
				
			</div>
			<div class="detailRow">
				<div class="detailCol">
					<div>优惠券：</div>
					<div>{{ detailData.coupon_list.length != 0 ? detailData.coupon_list[0].coupon_name : '--' }}</div>
				</div>
				<div class="detailCol">
					<div>优惠金额：</div>
					<div>{{ (detailData.order_price + detailData.postage - detailData.total_price).toFixed(2) }}</div>
				</div>
				<div class="detailCol">
					<div>总计金额：</div>
					<div>{{ detailData.total_price }}</div>
				</div>
				<div class="detailCol">
					<div>订单备注：</div>
					<div>{{ detailData.remark }}</div>
				</div>
			</div>
			<div class="detailRow">
			

				<div class="detailCol">
					<div>收货地址：</div>
					<div>{{ online_order_data.ship_adddress== null ? '--' :online_order_data.ship_adddress.province_name +online_order_data.ship_adddress.city_name + online_order_data.ship_adddress.district_name + online_order_data.ship_adddress.address
 }}</div>
				</div>
			</div>
		</div>
		<div class="tableWrap">
			<div class="tableView" v-if="detailData != null">
				<el-table :data="tableData" style="width: 100%" :default-expand-all="isExpand">
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div v-for="(item, index) in scope.row.order_item_goods_list" :key="index" class="codeItem">
								<div>{{ item.custom_code }} <span v-if="item.goods_type == 8">{{ item.goods_name }}</span></div>
								<i class="el-icon-error" style="font-size: 16px;"
									@click="handelDeleteClick(scope.$index, index)" v-if="item.goods_type != 8"></i>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="goods_name" label="商品">
					</el-table-column>
					<el-table-column prop="sku_value" label="规格">
					</el-table-column>
					<el-table-column prop="unit" label="单位">
					</el-table-column>
					<el-table-column prop="original_price" label="标准价">
					</el-table-column>
					<el-table-column label="活动">
						<template slot-scope='scope'>
							{{ scope.row.activity_info == null ? '--' : scope.row.activity_info.activity_name }}
						</template>
					</el-table-column>
					<el-table-column prop="price" label="优惠价">
					</el-table-column>
					<el-table-column prop="num" label="数量">
					</el-table-column>
					<el-table-column prop="price" label="支付金额">
						<template slot-scope="scope">{{ scope.row.price * scope.row.num }}</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 填写单号弹框 -->
		<div v-if="drawerTianxiedanhao_state">
			<drawerTianxiedanhao @closeOn="handleTianxiedanhaoClose" :comState="drawerTianxiedanhao_state"
				:navData="detailData" :navType="1">
			</drawerTianxiedanhao>
		</div>

		<!-- 物流信息弹框 -->
		<div v-if="drawerWuliuxinxi_state">
			<drawerWuliuxinxi @closeOn="drawerWuliuxinxi_state = false" :comState="drawerWuliuxinxi_state"
				:orderNo="detailData.no">
			</drawerWuliuxinxi>
		</div>
	</div>
</template>

<script>
import drawerTianxiedanhao from "./drawerTianxiedanhao.vue"
import drawerWuliuxinxi from "./drawerWuliuxinxi.vue"
export default {
	components: {
		drawerTianxiedanhao,
		drawerWuliuxinxi
	},
	data() {
		return {
			id: this.$route.query.id,
			tableData: [],
			user_info:[],
			detailData: null,
			drawerTianxiedanhao_state: false,
			drawerWuliuxinxi_state: false,
			code: '',
			isExpand: true,
			online_order_data: [], //配送方式
			distribution_shop: [],
            pick_up_store: [],
			ship_adddress: [],
		}
	},
	mounted() {
		console.log(this.id)
		this.getDetailData()
	},
	methods: {
		//确认收货
		handelReceivingClick() {
			let params = {
				orderNo: this.detailData.no
			}
			this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/finish/receiving', params).then((res) => {
				if (res.code == 0) {
					console.log(res.data)
					this.$message({
						type: 'success',
						message: '已收货'
					});
					this.getDetailData()
				}
			})
		},
		//确认发货
		handelConfirmClick() {
				this.detailData.order_item_list = this.tableData;
				this.drawerTianxiedanhao_state = true;
		},
		//关闭弹框
		handleTianxiedanhaoClose(val) {
			this.drawerTianxiedanhao_state = false;
			if (val.type == "submit") {
				this.getDetailData()
			}
		},
		//删除
		handelDeleteClick(index1, index2) {
			console.log(index1, index2)
			this.tableData[index1].order_item_goods_list.splice(index2, 1);
			console.log(this.tableData)
			this.$set(this.tableData, index1, this.tableData[index1])
		},
		//获取详情
		getDetailData() {
			let params = {
				id: this.id
			}
			this.$http.get(process.env.VUE_APP_Url_order + '/api/OnLineOrder/get', params).then((res) => {
				if (res.code == 0) {
					console.log('商品详情', res.data)
					this.detailData = res.data;
					this.user_info = res.data.user_info;
					this.online_order_data = res.data.online_order_data
                    // this.ship_adddress = res.data.online_order_data.ship_adddress,
                    // this.distribution_shop = res.data.online_order_data.distribution_shops
                    this.pick_up_store = res.data.online_order_data.pick_up_store
					if (res.data.order_item_list[0].goods_type == 8) {
						if (res.data.state == 1 || res.data.state == 2 || res.data.state == 3) {
							this.getComboDetail(res.data.order_item_list[0].goods_id)
						} else {
							this.tableData = res.data.order_item_list;
						}

					} else {
						if (res.data.state == 1 || res.data.state == 2 || res.data.state == 3) {
							res.data.order_item_list.map(item => {
								item.order_code_list = [];
							})
						}
						res.data.order_item_list.map(item => {
							item.code = [];
						})
						this.tableData = res.data.order_item_list;
					}
				}
			})
		},
		//获取套餐详情
		getComboDetail(id) {
			let params = {
				id: id
			}
			this.$http.get(process.env.VUE_APP_Url_baseData + '/api/product/group/goods/online/detail/info', params).then((res) => {
				if (res.code == 0) {
					console.log('套餐详情', res.data)
					res.data.groupDetails.map(item => {
						this.tableData.push({
							activity_info: null,
							code: [],
							goods_id: item.goodsId,
							goods_name: item.onlineTitle,
							goods_sales_model: 1,
							goods_type: 0,
							num: item.count,
							order_code_list: [],
							order_item_goods_list: [],
							original_price: item.price,
							packing_way_id: item.unitId,
							price: item.price,
							remarks: '',
							sku_value: item.skuName,
							skus_id: item.skuId,
							unit: item.unitName,
						})
					})
					console.log(this.tableData)
				}
			})
		},
		//返回
		handleBackClick() {
			this.$router.back();
		}
	}
}
</script>

<style lang="scss" scoped>
.page {
	padding: 16px 16px 0 16px;
	height: 100%;
	box-sizing: border-box;

	.topView {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;

		.topViewL {
			display: flex;
			align-items: center;
			font-size: 18px;
			color: #343440;
			font-weight: bold;

			div:nth-of-type(1) {
				width: 5px;
				height: 20px;
				background: linear-gradient(315deg, #338AFF 0%, #3F69FF 100%);
				border-radius: 4px;
				margin-right: 12px;
			}
		}
	}

	.detailView {
		margin-bottom: 16px;
		padding: 24px 32px;
		background: #fff;
		border-radius: 16px;

		.detailViewName {
			font-size: 16px;
			font-weight: bold;
			color: #343440;
		}

		.detailRow {
			display: flex;
			align-items: center;
			margin-top: 32px;
			font-size: 14px;
			justify-content: space-between;

			.detailCol {
				display: flex;
				align-items: center;
				width: 28%;

				div:nth-of-type(1) {
					width: 70px;
					text-align: right;
					color: #343440;
					font-weight: 400;
				}

				// div:nth-of-type(2) {
				// 	flex: 1;
				// 	overflow: hidden;
				// 	text-overflow: ellipsis;
				// 	white-space: nowrap;
				// 	color: #343440;
				// 	font-weight: 500;
				// }
			}
		}

	}

	.tableWrap {
		padding: 16px;
		background: #fff;
		border-radius: 8px;
		height: 440px;
		display: flex;
		flex-direction: column;

		.tableTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 40px;
			line-height: 40px;

			.tableTitleL {
				font-size: 16px;
				font-weight: bold;
				margin-left: 16px;
			}

			.tableTitleR {
				display: flex;
				align-items: center;
			}
		}

		.tableView {
			flex: 1;
			overflow-y: scroll;
			margin-top: 10px;

			.codeItem {
				// width: 146px;
				height: 32px;
				margin-left: 16px;
				background: #F7F7FA;
				font-size: 14px;
				display: flex;
				align-items: center;
				justify-content: center;
				float: left;
				margin-bottom: 10px;
				border-radius: 4px;
				padding: 0 10px;

				div {
					margin-right: 10px;
				}
			}
		}
	}

	.tableView::-webkit-scrollbar {
		display: none;
	}
}</style>
